// extracted by mini-css-extract-plugin
export default {"travelCompanionsFormWrapper":"TravelCompanions_travelCompanionsFormWrapper__fJ1AP","travelCompanionsFormLoading":"TravelCompanions_travelCompanionsFormLoading__qcqkj"};